import { render, staticRenderFns } from "./ContractorAbout.vue?vue&type=template&id=8b1c5db2&scoped=true"
import script from "./ContractorAbout.vue?vue&type=script&lang=ts"
export * from "./ContractorAbout.vue?vue&type=script&lang=ts"
import style0 from "./ContractorAbout.vue?vue&type=style&index=0&id=8b1c5db2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c5db2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b1c5db2')) {
      api.createRecord('8b1c5db2', component.options)
    } else {
      api.reload('8b1c5db2', component.options)
    }
    module.hot.accept("./ContractorAbout.vue?vue&type=template&id=8b1c5db2&scoped=true", function () {
      api.rerender('8b1c5db2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ContractorAbout.vue"
export default component.exports